var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.readonly && !_vm.isHidden
    ? _c("div", { staticClass: "form-data" }, [
        _c("p", {
          directives: [
            {
              name: "safe-html",
              rawName: "v-safe-html",
              value: _vm.labelWithPossibleRequiredSuffix,
              expression: "labelWithPossibleRequiredSuffix",
            },
          ],
          staticClass: "ob1-filled-label",
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "ob1-filled-data",
          attrs: { "data-cs-encrypt": _vm.anonymized ? "" : null },
          domProps: { textContent: _vm._s(_vm.modelValue) },
        }),
      ])
    : _c("div", { staticClass: "ob1-form-group" }, [
        _c("input", {
          directives: [{ name: "maska", rawName: "v-maska" }],
          ref: "textFieldInputRef",
          class: _vm.inputClassObject,
          attrs: {
            id: _vm.inputId,
            "data-maska": _vm.maskaData,
            "data-maska-eager": "",
            inputmode: _vm.inputModeValue,
            type: _vm.typeValue,
            "data-ob1-component": "FormControlEmpty",
            "aria-labelledby": _vm.labelId,
            "aria-required": _vm.isRequired,
            "aria-invalid": _vm.isInvalid ? "true" : null,
            "aria-describedby": _vm.ariaDescribedBy,
            minlength: _vm.minLength,
            maxlength: _vm.maxLength,
            disabled: _vm.isDisabled,
            required: _vm.isRequired,
            hidden: _vm.isHidden,
            autocomplete: _vm.autocomplete,
            "data-cs-mask": _vm.anonymized ? "" : null,
          },
          domProps: { value: _vm.modelValue },
          on: { input: _vm.onInput, blur: _vm.onBlur, paste: _vm.onPaste },
        }),
        _vm._v(" "),
        _c("label", {
          directives: [
            {
              name: "safe-html",
              rawName: "v-safe-html",
              value: _vm.labelWithPossibleRequiredSuffix,
              expression: "labelWithPossibleRequiredSuffix",
            },
          ],
          staticClass: "form-control-placeholder",
          attrs: { id: _vm.labelId, for: _vm.inputId },
        }),
        _vm._v(" "),
        _vm.isInvalid
          ? _c(
              "div",
              {
                staticClass:
                  "alert-container alert-container-sm alert-danger invalid-feedback",
              },
              [
                _c("p", { staticClass: "alert", attrs: { role: "alert" } }, [
                  _c("span", {
                    staticClass: "alert-icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("label", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: _vm.errorMessage,
                        expression: "errorMessage",
                      },
                    ],
                    staticClass: "ob1-alert-title",
                    attrs: { id: _vm.errorId, for: _vm.inputId },
                  }),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.helperText
          ? _c("div", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.helperText,
                  expression: "helperText",
                },
              ],
              staticClass: "form-control-help",
              attrs: { id: _vm.helperId },
            })
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }